import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import axios from 'axios';
import ManualSurvey from './ManualSurvey'
import Header from './Header'  


class EnqueteView extends React.Component {
    
   
    state = {
       count:0
   }
    constructor(){
        
        super();
        this.state={
            survey: {},
            isLoading: true,
          }
        
        }
    
        
    mapChoice = (choice) => 
    {
        const { ID,Omschrijving,Volgende } = choice   
          return (
           { value: ID,
            text: Omschrijving,
            volgende: Volgende
         }
        )
    }

    RadioButtonQuestion = (title, choices,id)=> {
        return { 
            type: "radiogroup",
            choices: choices.map(this.mapChoice),
            isRequired: true,
            name: JSON.stringify(id), 
            title
        }        
    }
    checkboxQuestion = (title, choices,id)=> {
        return { 
            type: "radiogroup",
            choices: choices.map(this.mapChoice),
            isRequired: true,
            name: JSON.stringify(id), 
            title
        }        
    }
    TextboxQuestion = (title, choices,id)=> {
        return { 
            type: "radiogroup",
            choices: choices.map(this.mapChoice),
            isRequired: true,
            name: JSON.stringify(id), 
            title
        }        
    }
    DropdownQuestion = (title, choices, id, volgorde)=> {
        return { 
            type: "radiogroup",
            choices: choices.map(this.mapChoice),
            isRequired: true,
            requiredErrorText:'Maak een keuze',
            name:id,
            title,
            volgordePos:volgorde
        }        
    }
    mapQuestion = (question) => {
        return {
            type: question.TypeObject,
            choices: 
            [].concat(question.Antwoorden)
            .sort((a, b) => a.Volgorde > b.Volgorde ? 1 : -1)
            .map(this.mapChoice),       
            isRequired: true,
            name:question.ID,
            title:question.Omschrijving,
            volgordePos:question.Volgorde
        }
    }

   
    
    createPages = (pages,logo,text) => {
       
        let pageIndex = 0
        
        return pages.map(page => {
                
            pageIndex++;
            
            return {
                    name:(`page${pageIndex}`),
                    questions: [(this.mapQuestion(page,pageIndex,logo,text))]
                 
                }
        })
    
    }
  

    mapResponseToState = (data,id) => {
                 const { ID,VragenLijst,EnqueteName,StartPagina,AfsluitText } = data
                  const result = 
                   {
                        ID: ID,
                        title: EnqueteName,                                   
                        questions: VragenLijst.map(this.mapQuestion),
                        bgcolor: StartPagina.KleurAchtergrond,
                        color:StartPagina.KleurText,
                        completed:AfsluitText         
                   }
                   return result
                   
    }

    componentDidMount = async () => {
        const { id } = this.props.match.params
        const url=`https://test.kto.nu/api/survey/${id}`
       try {
            const response = await axios.get(url, {
            })
            this.setState({survey: this.mapResponseToState(response.data,id), isLoading: false, id,completedHtml:response.data.AfsluitText});           
        }
            catch (error)   
            {
             <h1>Er is iets foutgegaan, probeer het opnieuw.</h1>
            }
               
        
        }

    
    createResponse = (list) => {
       var result = []
       list.map((item) => (
            item.value ? 
            item.isOpenText?
            result.push(
                {
                "OpenText": item.value,
                "IsOpenText": item.isOpenText,
                "AntwoordID": null,
                "VraagID": item.id
            })
            :
            result.push(
                {
                "OpenText": "",
                "IsOpenText": false,
                "AntwoordID": item.value,
                "VraagID": item.id
            })
            :
            false
        ))

        return result;
    }    
            

    handleSurveyComplete = (data,isAborted) => {
        const { id } = this.props.match.params
        const respons = {

            queueID: id,
            mobileGeenEnquete: isAborted,
            ontvangenAntwoorden:  this.createResponse(data)
          }
       const url="https://test.kto.nu/api/survey/" + id
       console.log('respons',respons)
       try {
       const response = axios.put(url,respons)
       }catch (error)
            {
              if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {  
                console.log(error.request);
            } else {    
                console.log('Error', error.message);
            }
            console.log('gaatniet',error)      
            }       
    }

    render() {
            
            const {survey, isLoading} = this.state;
                     
        return (
            isLoading ? 'loading...': 
            <div>
            <Header title={survey.title} color={survey.color}></Header>
            <ManualSurvey 
            json={survey} 
            onComplete={ this.handleSurveyComplete}
             />
             </div>
        )
                       
                   
    }

}

export default EnqueteView
